/* eslint-disable react/prop-types */
import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import HeaderPDF from './HeaderPDF';
// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 30,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 20,
    color: '#2c3e50',
  },
  section: {
    marginBottom: 15,
    padding: 10,
    backgroundColor: '#f8f9fa',
    borderRadius: 5,
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 10,
    color: '#34495e',
    borderBottom: '1px solid #bdc3c7',
    paddingBottom: 5,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5,
  },
  column: {
    flex: 1,
    marginRight: 10,
  },
  label: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#7f8c8d',
    marginBottom: 2,
  },
  value: {
    fontSize: 10,
    color: '#2c3e50',
    marginBottom: 8,
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderColor: '#bdc3c7',
    marginBottom: 10,
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
  },
  tableColHeader: {
    width: '25%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderColor: '#bdc3c7',
    backgroundColor: '#f8f9fa',
    padding: 5,
  },
  tableCol: {
    width: '25%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderColor: '#bdc3c7',
    padding: 5,
  },
  tableCellHeader: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#34495e',
  },
  tableCell: {
    fontSize: 9,
    color: '#2c3e50',
  },
  signatureSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  signatureBox: {
    width: '45%',
    padding: 10,
    border: '1px solid #bdc3c7',
    borderRadius: 5,
  },
  signatureTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center',
    color: '#34495e',
  },
  footer: {
    marginTop: 20,
    padding: 10,
    borderTop: '1px solid #bdc3c7',
    fontSize: 8,
    color: '#7f8c8d',
    textAlign: 'center',
  },
 
  note: {
    fontSize: 8,
    color: '#7f8c8d',
    fontStyle: 'italic',
    marginTop: 5,
  },
  badgeContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 5,
  },
  badge: {
    backgroundColor: '#007bff',
    color: '#ffffff',
    fontSize: 9,
    fontWeight: 'bold',
    padding: '4 8',
    borderRadius: 3,
    marginRight: 5,
    marginBottom: 3,
  },
  badgeInactive: {
    backgroundColor: '#e9ecef',
    color: '#6c757d',
    fontSize: 9,
    padding: '4 8',
    borderRadius: 3,
    marginRight: 5,
    marginBottom: 3,
  }
});

const ExportPDFEmployerFdwInterview = ({ user, data,agencyInfo }) => {


  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <HeaderPDF user={user} agencyInfo={agencyInfo} />
        <Text style={styles.title}>Employer FDW Interview</Text>
        
        {/* Interview Mode */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Interview Details</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Interview Mode:</Text>
              <View style={styles.badgeContainer}>
                <Text style={data.mode?.includes('Telephone') ? styles.badge : styles.badgeInactive}>
                  Telephone
                </Text>
                <Text style={data.mode?.includes('Video') ? styles.badge : styles.badgeInactive}>
                  Video
                </Text>
                <Text style={data.mode?.includes('In Person') ? styles.badge : styles.badgeInactive}>
                  In Person
                </Text>
              </View>
            </View>
          </View>
        </View>

        {/* Personal Information */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Personal Information</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>FDW Name:</Text>
              <Text style={styles.value}>{data.fdwName || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Nationality:</Text>
              <Text style={styles.value}>{data.nationality || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Date of Birth:</Text>
              <Text style={styles.value}>{data.dob || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Age:</Text>
              <Text style={styles.value}>{data.age || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Passport Number:</Text>
              <Text style={styles.value}>{data.passport || 'Not specified'}</Text>
            </View>
          </View>
        </View>

        {/* Work Experience */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Work Experience</Text>
          
          {/* Work Experience Table */}
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={styles.tableColHeader}>
                <Text style={styles.tableCellHeader}>Experience</Text>
              </View>
              <View style={styles.tableColHeader}>
                <Text style={styles.tableCellHeader}>Work Place</Text>
              </View>
              <View style={styles.tableColHeader}>
                <Text style={styles.tableCellHeader}>Years</Text>
              </View>
              <View style={styles.tableColHeader}>
                <Text style={styles.tableCellHeader}>Employers</Text>
              </View>
            </View>
            
            {/* Work Experience 1 */}
            <View style={styles.tableRow}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Experience 1</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{data.workPlace1 || 'Not specified'}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{data.workYears1 || 'Not specified'}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{data.workEmployers1 || 'Not specified'}</Text>
              </View>
            </View>
            
            {/* Work Experience 2 */}
            <View style={styles.tableRow}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Experience 2</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{data.workPlace2 || 'Not specified'}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{data.workYears2 || 'Not specified'}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{data.workEmployers2 || 'Not specified'}</Text>
              </View>
            </View>
          </View>
        </View>

        {/* Language Skills */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Language Skills</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Spoken English:</Text>
              <Text style={styles.value}>{data.spokenEnglish || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Written English:</Text>
              <Text style={styles.value}>{data.writtenEnglish || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Other Language:</Text>
              <Text style={styles.value}>{data.otherLanguage || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Other Language Skill:</Text>
              <Text style={styles.value}>{data.otherLangSkill || 'Not specified'}</Text>
            </View>
          </View>
        </View>

        {/* Skills Assessment */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Skills Assessment</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Alertness:</Text>
              <Text style={styles.value}>{data.alertness || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Cooking:</Text>
              <Text style={styles.value}>{data.cooking || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Equipment Handling:</Text>
              <Text style={styles.value}>{data.equipment || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Domestic Knowledge:</Text>
              <Text style={styles.value}>{data.domesticKnowledge || 'Not specified'}</Text>
            </View>
          </View>
        </View>

        {/* Care Skills */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Care Skills</Text>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Infant Care:</Text>
              <Text style={styles.value}>{data.infantCare || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Child Care:</Text>
              <Text style={styles.value}>{data.childCare || 'Not specified'}</Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={styles.column}>
              <Text style={styles.label}>Elderly Care:</Text>
              <Text style={styles.value}>{data.elderlyCare || 'Not specified'}</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.label}>Pet Care:</Text>
              <Text style={styles.value}>{data.petCare || 'Not specified'}</Text>
            </View>
          </View>
        </View>

        {/* Signatures */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Interview Signatures</Text>
          <View style={styles.signatureSection}>
            <View style={styles.signatureBox}>
              <Text style={styles.signatureTitle}>Employer Details</Text>
              <Text style={styles.label}>Employer Name:</Text>
              <Text style={styles.value}>{data.employerName || ''}</Text>
              <Text style={styles.label}>NRIC:</Text>
              <Text style={styles.value}>{data.employerNric || ''}</Text>
              <Text style={styles.label}>Signature & Date:</Text>
              <Text style={styles.value}>{data.employerSignature || ''}</Text>
              <Text style={styles.label}>Date:</Text>
              <Text style={styles.value}>{data.employerDate || ''}</Text>
            </View>

            <View style={styles.signatureBox}>
              <Text style={styles.signatureTitle}>EA Details</Text>
              <Text style={styles.label}>EA Name:</Text>
              <Text style={styles.value}>{data.eaName || ''}</Text>
              <Text style={styles.label}>EA Registration:</Text>
              <Text style={styles.value}>{data.eaReg || ''}</Text>
              <Text style={styles.label}>EA Signature:</Text>
              <Text style={styles.value}>{data.eaSignature || ''}</Text>
            </View>
          </View>
        </View>

        {/* Footer */}
        <View style={styles.footer}>
          <Text>Employer FDW Interview Generated on {new Date().toLocaleDateString()}</Text>
          {user && (
            <Text>Agency: {user.company?.name || 'Not specified'}</Text>
          )}
        </View>
      </Page>
    </Document>
  );
};

export default ExportPDFEmployerFdwInterview;
